export default __webpack_public_path__ + "static/media/demolition_responsive.e4f5fbf5.png";